import React from 'react'
import {
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

interface DividerWithTextProps {
  text?: string
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  lineColor?: string
  textColor?: string
}
export const DividerWithText: React.FC<DividerWithTextProps> = ({
  paragraph,
  theme,
  text,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: `19px`,
        margin: '24px 0',
      }}
    >
      <span style={{ flex: 1, height: '1px', backgroundColor: '#D1D5DB' }} />
      <span
        style={{
          color: theme?.text.paragraphTextColor,
          fontSize: paragraph?.fontSize,
          fontFamily: paragraph?.fontFamily,
          whiteSpace: 'nowrap',
        }}
      >
        {text}
      </span>
      <span
        aria-hidden="true"
        style={{ flex: 1, height: '1px', backgroundColor: '#D1D5DB' }}
      />
    </div>
  )
}

export default DividerWithText
